import React, { type ReactElement } from 'react'
import { ResumePaymentRadioSection } from './ResumePaymentRadioSection'

interface ResumeChargesSectionProps {
  isActive: boolean
}
export function ResumeChargesSection ({ isActive }: ResumeChargesSectionProps): ReactElement {
  //if the parent recurring payment is active, we want to hide this section...BC
  if (isActive) {
    return <></>
  }

  return (
    <div>
      <div className="mb-8">
        <div className="text-xl pb-2">Resume Recurring Charge?</div>
        <p className="text-gray-600">
          This recurring charge stopped on failure. Set the next occurrence date to resume charges after a successful retry, or choose to keep it paused.
        </p>
      </div>
      <ResumePaymentRadioSection />
    </div>

  )
}
